<!--FormularioAuto-->
<template>
  <div>
    <!-- Para Marca (siempre habilitado) -->
    <div class="mb-3">
      <SelectMasInput 
        :isOpen="selectedSearch === 'Marca'" 
        @setSelectMasInput="setSelectMasInputBrand"
        :hasDefaultOption="true" 
        :placeholderName="'Marca'" 
        :data="brands" 
        @changeValue="onChangeBrand"
        :isLoading="loadingBrands" 
        :isEnabled="true" 
      />
    </div>

    <!-- Para Año (habilitado si hay marca seleccionada) -->
    <div class="mb-3">
      <SelectMasInput 
        :isOpen="selectedSearch === 'Año'" 
        @setSelectMasInput="setSelectMasInputYear" 
        :placeholderName="'Año'"
        :data="years" 
        @changeValue="onChangeYear" 
        :isLoading="loadingYears" 
        :hasDefaultOption="true"
        :hasNumberValidation="true" 
        :maxNumberLength="4" 
        :isEnabled="!!selectedBrand" 
      />
    </div>

    <!-- Para Modelo (habilitado si hay año seleccionado) -->
    <div class="mb-3">
      <SelectMasInput 
        :isOpen="selectedSearch === 'Modelo'" 
        @setSelectMasInput="setSelectMasInputModel" 
        :placeholderName="'Modelo'"
        :data="models" 
        @changeValue="onChangeModel" 
        :isLoading="loadingModels" 
        :hasDefaultOption="true"
        :isEnabled="!!selectedYear" 
      />
    </div>

    <!-- Para Versión (habilitado si hay modelo seleccionado) -->
    <div class="">
      <SelectMasInput 
        :isOpen="selectedSearch === 'Versión'" 
        @setSelectMasInput="setSelectMasInputVersion"
        :placeholderName="'Versión'" 
        :data="versions" 
        @changeValue="onChangeVersion" 
        :isLoading="loadingVersions"
        :hasDefaultOption="true" 
        :isEnabled="!!selectedModel" 
      />
    </div>
  </div>
</template>

<script setup>
import SelectMasInput from "~/components/Selectores/SelectMasInput.vue";

const props = defineProps({
  selectedSearch: String,
  brands: Array,
  years: Array,
  models: Array,
  versions: Array,
  loadingBrands: Boolean,
  loadingYears: Boolean,
  loadingModels: Boolean,
  loadingVersions: Boolean,
  selectedBrand: [String, Number],
  selectedYear: [String, Number],
  selectedModel: [String, Number]
});

const emit = defineEmits([
  'setSelectMasInputBrand',
  'setSelectMasInputYear',
  'setSelectMasInputModel',
  'setSelectMasInputVersion',
  'onChangeBrand',
  'onChangeYear',
  'onChangeModel',
  'onChangeVersion'
]);

const setSelectMasInputBrand = (value) => emit('setSelectMasInputBrand', value);
const setSelectMasInputYear = (value) => emit('setSelectMasInputYear', value);
const setSelectMasInputModel = (value) => emit('setSelectMasInputModel', value);
const setSelectMasInputVersion = (value) => emit('setSelectMasInputVersion', value);

const onChangeBrand = (value) => emit('onChangeBrand', value);
const onChangeYear = (value) => emit('onChangeYear', value);
const onChangeModel = (value) => emit('onChangeModel', value);
const onChangeVersion = (value) => emit('onChangeVersion', value);
</script>
